import type {
  Agent,
  CheckoutDeliveryFragment,
  DeliveryOptionFragment,
} from "@server/gql/graphql";

import { formatPrice } from "@/utils/priceUtils";

export type DeliveryOptionImage = NonNullable<CheckoutDeliveryFragment["image"]>;

export type DeliveryAgent = {
  id: string;
  name: string;
  city?: string;
  address?: string;
};
export type DeliveryOption = {
  id: string;
  name: string;
  price: number;
  agent?: string;
  agents?: DeliveryAgent[];
  carrier: string;
  description: string;
  prettyPrice?: string;
  extraDescription: string;
};

function transformDeliveryAgent(
  incomingDeliveryAgent: Agent | null,
): DeliveryAgent | undefined {
  if (!incomingDeliveryAgent) return;
  const outgoingDeliveryAgent: DeliveryAgent = {
    id: incomingDeliveryAgent.id,
    name: incomingDeliveryAgent.name ?? "",
    city: incomingDeliveryAgent.city ?? undefined,
    address: incomingDeliveryAgent.address1 ?? undefined,
  };
  return outgoingDeliveryAgent;
}

export function transformDeliveryOption(
  incomingDeliveryOption: DeliveryOptionFragment | null,
  locale?: string,
): DeliveryOption | undefined {
  if (!incomingDeliveryOption) return;

  const agents = incomingDeliveryOption.agents?.map(transformDeliveryAgent);
  const outgoingDeliveryOption: DeliveryOption = {
    id: incomingDeliveryOption.id,
    name: incomingDeliveryOption.name,
    agent: incomingDeliveryOption.noDefaultAgent ? undefined : agents?.[0]?.id,
    agents: agents?.filter<DeliveryAgent>((agent) => agent !== undefined),
    price: incomingDeliveryOption.priceValue,
    carrier: incomingDeliveryOption.carrierId,
    description: incomingDeliveryOption.description1,
    prettyPrice: formatPrice(
      incomingDeliveryOption.priceValue,
      locale,
      undefined,
      false,
    ),
    extraDescription: incomingDeliveryOption.description2,
  };
  return outgoingDeliveryOption;
}
